module.exports = __webpack_public_path__ + "img/hohlschnitt_anthrazitgrau_ral7016.7b43c995.jpg";